import fetch from '@/utils/fetch';

// 新增或发布通知
export function addOrPublishSchoolEnrolNotice(args) {
    let params = new URLSearchParams();
    params.append('beginYear', args.beginYear);
    params.append('content', args.content);
    params.append('endTime', args.endTime);
    params.append('endYear', args.endYear);
    params.append('enrolType', args.enrolType);
    params.append('isDelete', 1);
    params.append('logoURL', args.logoURL);
    params.append('publishTo', args.publishTo);
    params.append('publishType', args.publishType);
    params.append('startTime', args.startTime);
    params.append('state', args.state);
    params.append('title', args.title);
    params.append('yearNum', args.yearNum);

    return fetch({
        url: 'structure/staterunEnrol/addOrPublishSchoolEnrolNotice',
        method: 'post',
        data: params
    });
}

// 编辑或发布通知
export function editOrPublishSchoolEnrolNotice(args) {
    let params = new URLSearchParams();
    params.append('id', args.id);
    params.append('beginYear', args.beginYear);
    params.append('content', args.content);
    params.append('endTime', args.endTime);
    params.append('endYear', args.endYear);
    params.append('enrolType', args.enrolType);
    params.append('isDelete', 1);
    params.append('logoURL', args.logoURL);
    params.append('publishTo', args.publishTo);
    params.append('publishType', args.publishType);
    params.append('startTime', args.startTime);
    params.append('state', args.state);
    params.append('title', args.title);
    params.append('yearNum', args.yearNum);

    return fetch({
        url: 'structure/staterunEnrol/editOrPublishSchoolEnrolNotice',
        method: 'post',
        data: params
    });
}

// 删除通知
export function delSchoolEnrolNoticeByIds(args) {
    let params = new URLSearchParams();
    params.append('noticeIds', args.noticeIds);

    return fetch({
        url: 'structure/staterunEnrol/delSchoolEnrolNoticeByIds',
        method: 'post',
        data: params
    });
}

// 获取通知列表不分页
export function getSchoolEnrolNoticeList(args) {
    let params = new URLSearchParams();
    params.append('searchVal', args.searchVal);

    return fetch({
        url: 'structure/staterunEnrol/getSchoolEnrolNoticeList',
        method: 'post',
        data: params
    });
}

// 获得学校的报名通知列表（分页）
export function getSchoolEnrolNoticePageList(args) {
    let params = new URLSearchParams();
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('searchVal', args.searchVal);
    params.append('state', args.state);

    return fetch({
        url: 'structure/staterunEnrol/getSchoolEnrolNoticePageList',
        method: 'post',
        data: params
    });
}

// 根据通知id查通知
export function getNotice(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'common/staterunEnrolStudent/getNotice',
        method: 'post',
        data: params
    });
}

//获取基本信息
export function getBasicInfo() {
    return fetch({
        url: 'structure/news/getBasicInfo',
        method: 'POST'
    });
}

// 查询学校安装的公众号信息
export function queryInfo() {
    return fetch({
        url: 'school/wxsmp/queryInfo',
        method: 'POST'
    });
}
// 开启-关闭招生补录
export function openOrCloseStateRunAdd(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);
    params.append('openState', args.openState);

    return fetch({
        url: 'structure/staterunEnrol/openOrCloseStateRunAdd',
        method: 'post',
        data: params
    });
}



// WEBPACK FOOTER //
// ./src/api/primary/notice.js